export default {
    "dropOff": "Drop Off",
    "pickUp": "Pick Up"
}
